import {Routes, Route } from "react-router-dom";
import React, { Suspense } from "react";

// Layouts
import PortfolioLayout from "../layouts/PortfolioLayout";
import AdminLayout from "../layouts/AdminLayout";

//admin pages
import Login from "../pages/admin/Login";
import Dashboard from "../pages/admin/Dashboard";
import ProfileEditor from "../pages/admin/ProfileEditor";

// Portfolio pages
import About from "../pages/portfolio/About";
import AiAssistant from "../pages/portfolio/AiAssistant";

// Code learning pages
import Counter from "../components/test-components/Test";
import MemoExample from "../components/test-components/MemoExapmple";
import DebounceExample from "../components/test-components/DebounceExample";
import ChatSocket from "../components/test-components/ChatSocket";

// Lazy imports after
const Contact = React.lazy(() => import("../pages/portfolio/Contact"))
const Projects = React.lazy(() => import("../pages/portfolio/Projects"));
const UserList = React.lazy(() => import("../components/test-components/UserList"));

const ApplicationRouter = () => {
  return (<>
      <Suspense fallback = {<p>Loading page...</p>}>
        <Routes>

            {/* Standalone routes (no layout) */}
            <Route path="/ai-assistant" element = {<AiAssistant/>} />

            {/* Portfolio routes */}
            <Route element = { <PortfolioLayout />}>
                <Route path="/*" element = {<About/>} />
                <Route path="/contact" element = {<Contact/>} />
                <Route path="/projects" element = {<Projects/>} />
                <Route path="/test" element = {<Counter name = "Adam"/>}/>
                <Route path="/memo" element = {<MemoExample/>}></Route>
                <Route path="/chat" element = {<ChatSocket/>}></Route>
                <Route path="/debounce" element = {<DebounceExample/>}></Route>
                <Route path="/userlist" element = {<UserList/>}/ >
            </Route>
  
            {/* Admin routes */}
            <Route element = { <AdminLayout />}>
                <Route path="/admin" element = {<Login/>}></Route>
                <Route path="/dashboard" element = {<Dashboard/>}></Route>
                <Route path="/dashboard/profile" element = {<ProfileEditor/>}></Route>
            </Route>
        </Routes>
      </Suspense>
  </>)
}

export default ApplicationRouter